import {
  boardContextEn,
  boardContextRu,
  boardCrmContextEn,
  boardCrmContextRu
} from './board'
import {
  columnContextEn,
  columnContextRu,
  columnCrmContextEn,
  columnCrmContextRu
} from './column'
import {
  commonContextEn,
  commonContextRu,
  commonCrmContextEn,
  commonCrmContextRu
} from './common'
import {
  rightPannelContextEn,
  rightPannelContextRu,
  rightPannelCrmContextEn,
  rightPannelCrmContextRu
} from './right-pannel'

export const contextEn = {
  common: commonContextEn,
  board: boardContextEn,
  column: columnContextEn,
  rightPanel: rightPannelContextEn
}

export type Context = typeof contextEn

export const contextRu: Context = {
  common: commonContextRu,
  board: boardContextRu,
  column: columnContextRu,
  rightPanel: rightPannelContextRu
}

export const crmContextEn: Context = {
  common: commonCrmContextEn,
  board: boardCrmContextEn,
  column: columnCrmContextEn,
  rightPanel: rightPannelCrmContextEn
}

export const crmContextRu: Context = {
  common: commonCrmContextRu,
  board: boardCrmContextRu,
  column: columnCrmContextRu,
  rightPanel: rightPannelCrmContextRu
}

export type ContextType = 'default' | 'crm'

export const context: {
  [contextType in ContextType]: {[lang in 'ru' | 'en']: Context}
} = {
  default: {
    en: contextEn,
    ru: contextRu
  },
  crm: {
    en: crmContextEn,
    ru: crmContextRu
  }
}
